<template>
  <v-calendar class="custom-calendar" v-bind:min-date="this.attributes[0].dates" v-bind:masks="masks" v-bind:attributes="attributes" disable-page-swipe is-expanded>
    <template v-slot:day-content="{ day, attributes }">
      <span class="h-full flex items-center justify-center font-primary font-semibold text-[21px] text-white bg-curious-blue p-[5px] rounded-[5px]" v-for="attr in attributes" v-bind:key="attr.key">
        {{ day.day }}
      </span>
    </template>
  </v-calendar>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'TripCalendar',
  data () {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: _.map(window.trip_post_script_data.attributes, attribute => {
        return {
          key: attribute.key,
          dates: moment(attribute.dates, 'DD/MM/YYYY').toDate(),
        };
      }),
    };
  },
};
</script>
<style lang="scss">
.vc-container {
  &.custom-calendar {
    @apply w-full;
    .vc-pane-container {
      .vc-pane-layout {
        .vc-pane {
          .vc-weeks {
            .vc-day {
              @apply min-h-[50px] m-[5px];
            }
          }
        }
      }
    }
  }
}
</style>
